<template>
<div class="flex flex-wrap justify-start align-items-center px-4 py-2 w-full">
    <avatar-icon size="lg" type="notification" />
    <div class="ml-4 flex flex-wrap flex-column justify-between flex-inline mr-4 mt-2">
        <div style="width:75%;" class="truncate truncate-2 mt-2">{{ data.title }}
            <small class="text-right flex-wrap mt-4 ml-2" style="color: #999999; font-size: 8px">{{ data.created_at | fromNow }}</small>

        </div>
    </div>
    <div class="left-image"></div>
</div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
        },
    },
    components: {
        AvatarIcon: () => import("@/components/general/avatar.vue"),
    },
};
</script>

<style lang="scss" scoped>
.left-image {
    img {
        height: 48px;
        border-radius: 5px;
        width: 48px;
    }
}
</style>
